// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import HoverMRRDescription from './HoverMRRDescription'
import HoverDifferenceDescription from './HoverDifferenceDescription'

// JS Imports
import {
   formatFloatAsCurrencySymbol,
   formatFloatAsPercent,
} from '../../../common/helpers.mjs'
// Asset Imports

export default function PerformanceProductRow() {
   const state = useQuoteContext()
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   if (state.product_list['performanceMan']?.NotInPricebook) {
      return <> </>
   }

   if (state.product_list.hasOwnProperty('performanceMan') == true)
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['performanceMan']['ProductName']} (
               {formatFloatAsCurrencySymbol(
                  state.product_list['performanceMan']['EmpListPrice'],
                  state.currencyObject,
               )}
               )
            </div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='number'
                  min={0}
                  placeholder={'0'}
                  value={
                     state.productPerformanceEECount <= 0
                        ? ''
                        : state.productPerformanceEECount.toString()
                  }
                  onChange={(e) =>
                     state.onProductPerformanceEECountChange(
                        Number(e.target.value),
                     )
                  }
                  onBlur={(e) =>
                     state.productPerformanceEECount < 1
                        ? 0
                        : state.onProductPerformanceEECountChange(
                             Math.floor(state.productPerformanceEECount),
                          )
                  }
               />
            </div>
            <div className='col col-bhr-red'>
               {formatFloatAsPercent(
                  state.productPerformanceMonthlyCosts
                     .volumeDiscountedPEPMPercent,
               )}
            </div>
            <div className='col'></div>
            <div className='col'>
               {state.productPerformanceMonthlyCosts.discountedPEPMCost <=
               state.productPerformanceMonthlyCosts.listPEPMCost
                  ? formatFloatAsCurrencySymbol(
                       state.productPerformanceMonthlyCosts.discountedPEPMCost,
                       state.currencyObject,
                    )
                  : ''}
            </div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.productPerformanceMonthlyCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <HoverDifferenceDescription
                     previousPlan={
                        state.accountSnowflake.Performance_Rate_Plan__c
                     }
                     previousQuantity={
                        state.accountSnowflake.Billed_Performance__c
                     }
                     previousInvoicedAmount={
                        state.productPerformanceMonthlyCosts
                           .previousTotalPriceUnconverted
                     }
                     previousStartDate={
                        state.accountSnowflake.Performance_Start_Date__c
                     }
                     previousCurrencyObject={state.currencyObjectPrevious}
                     placement='bottom'
                  >
                     <span className='hoverable'>
                        {formatFloatAsCurrencySymbol(
                           state.productPerformanceMonthlyCosts
                              .previousTotalPrice,
                           state.currencyObject,
                        )}
                     </span>
                  </HoverDifferenceDescription>
                  {ShowMRROnDifferenceQuotes ? (
                     <HoverMRRDescription
                        listMRRTotal={
                           state.productPerformanceMonthlyCosts.listMRRTotal
                        }
                        previousMRRTotal={
                           state.productPerformanceMonthlyCosts.previousMRRTotal
                        }
                        MRRTotal={state.productPerformanceMonthlyCosts.MRRTotal}
                        MRRTotalUSD={
                           state.productPerformanceMonthlyCosts.MRRTotalUSD
                        }
                        currencyObjectCurrent={state.currencyObject}
                        currencyObjectUSD={state.currencyObjectUSD}
                     >
                        <span className='hoverable'>
                           {formatFloatAsCurrencySymbol(
                              state.productPerformanceMonthlyCosts
                                 .totalPriceDifference,
                              state.currencyObject,
                           )}
                        </span>
                     </HoverMRRDescription>
                  ) : (
                     <span className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.productPerformanceMonthlyCosts
                              .totalPriceDifference,
                           state.currencyObject,
                        )}
                     </span>
                  )}
                  {process.env.REACT_APP_ENVIRONMENT == 'staging' && (
                     <div className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.productPerformanceMonthlyCosts.MRRTotal,
                           state.currencyObject,
                        )}
                     </div>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
